import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { decorateElement } from 'fg-frontend/src/webComponents/decorate';

tinymce.baseURL = '/tinymce';

class ForumUpdateActions extends WebComponent {

  constructor(props) {
    super(props);
  }

  didMount() {
    this.on('click', this.handleClick);
  }

  handleClick = (event) => {
    const {
      buttonActiveClass,
    } = this.props;

    event.preventDefault();

    if (!this.element.classList.contains(buttonActiveClass)) {

      const postId = this.element.getAttribute('id').replace('update-post-', '');
      const content = document.querySelector('#post-' + postId + ' .wysiwyg-content').innerHTML;

      const activeButtons = document.querySelectorAll(`.${buttonActiveClass}`);
      if (activeButtons.length > 0) {
        activeButtons.forEach((hiddenButton) => {
          hiddenButton.classList.remove(buttonActiveClass);
          hiddenButton.parentElement.nextElementSibling.remove();
        });
      }

      this.element.classList.add(buttonActiveClass);
      $.get(this.element.getAttribute('href'), (data) => {
        this.element.parentElement.insertAdjacentHTML('afterend', `<div class="forum__loaded-content">${data}</div>`);
        const textArea = this.element.parentElement.parentElement.querySelectorAll('#body')[0];
        const random = Math.floor(Math.random() * 1000000) + 1;
        textArea.setAttribute('id', 'body-' + random);
        textArea.value = content;
        decorateElement(textArea);
      });
    }
    else {
      this.element.classList.remove(buttonActiveClass);
      this.element.parentElement.nextElementSibling.remove();
    }
  }
}

ForumUpdateActions.defaultProps = {
  buttonActiveClass: 'forum__btn-reaction--active',
};

export default ForumUpdateActions;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ForumUpdateActions.js